<template>
    <div class="row">
        <div class="col-12 mt-3">
            <company-certificates
                :breads="false"
                :returnButton="false"
                :isProfile="true"
                :companyProp="this.$store.state.userSelectedRole.company_id">
            </company-certificates>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import companyCertificates from '@/components/pages/companies/company_certificates.vue';

export default {
    name: 'profile_company_certificates',
    components: {
        companyCertificates
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/users/profile/profile_company_certificates.vue